import React from 'react';
import styles from './RecentTransactionsTable.module.scss';
import { useSelector } from 'react-redux';
import { getRecentTransactionList } from '../../../redux/modules/recentTransactions/recentTransactions.selectors';

const AccountName = ({
  accountType,
  fundName,
  agreementNumber,
  owners,
  ticker,
}) => {
  const line1 = [fundName, accountType].filter(Boolean).join(' - ');
  return (
    <>
      {Boolean(line1) && (
        <div>
          <span>{line1}</span> <small>{ticker}</small>
        </div>
      )}
      <div className="blocked_data">
        {Boolean(agreementNumber) && <>{agreementNumber}</>} •
        {owners.join(', ')}
      </div>
    </>
  );
};

const RecentTransactionsTable = () => {
  const transactions = useSelector(getRecentTransactionList); // will be a use selector returning recent transactions

  return (
    <div className={styles['view-port']}>
      <div className={styles['container']}>
        <div className={styles['text-section']}>
          <div className={styles['title']}>Recent Transactions</div>
          <div className={styles['text-block']}>
            * The following transactions reflect movement out of IRA accounts.
          </div>
          {/* trade date, transaction detail, account name, quantity, price, net dollar amount */}
          <div className={styles['table-container']} tabindex="0">
            <table className={styles['table']}>
              <thead>
                <tr className={styles['table-title']}>
                  <th className={styles['header']}>Trade Date</th>
                  <th className={styles['header']}>Transaction Detail</th>
                  <th className={styles['header']}>Account Name</th>
                  <th className={styles['header-num']}>Quantity</th>
                  <th className={styles['header-num']}>Price</th>
                  <th className={styles['header-num']}>Net Dollar Amount</th>
                </tr>
              </thead>
              {transactions.map(
                ({ detail, displayDate, qty, price, amt, accountInfo }) => (
                  <tr className={styles['table-elements']}>
                    <td className={styles['body']}>{displayDate}</td>
                    <td className={`${styles['body']} blocked_data`}>
                      {detail}
                    </td>
                    <td className={styles['account-name']}>
                      <AccountName {...accountInfo} />
                    </td>
                    <td className={styles['num']}>{qty.toFixed(3)}</td>
                    <td className={styles['num']}>{price}</td>
                    <td className={`${styles['num']} ${styles['emphasis']}`}>
                      {amt}
                    </td>
                  </tr>
                )
              )}
              {/* <div className={styles["dropDown"]}>View all Transactions ^</div> */}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentTransactionsTable;
